import { Badge } from "./Badge";
import type { ReportRow } from "../api/reports";
import { parseStructured } from "../api/reports";

export function ReportListCard({
  row,
  selected,
  onSelect,
}: {
  row: ReportRow;
  selected: boolean;
  onSelect: (id: string) => void;
}) {
  const payload = parseStructured(row);
  const summary =
    payload?.headline ??
    (row.summaryMarkdown ?? "").replace(/^#+\s*/gm, "").slice(0, 120);

  return (
    <button
      onClick={() => onSelect(row.id)}
      className={[
        "text-left bg-bg-card rounded-[13px] p-4 w-full transition-all block",
        "border",
        selected
          ? "border-accent shadow-selected"
          : "border-border-default hover:border-accent",
      ].join(" ")}
    >
      <div className="flex items-center gap-2 mb-1">
        <span className="text-[13.5px] font-semibold text-text-primary">
          {row.reportDate}
        </span>
        <Badge variant={row.messageCount > 0 ? "ok" : "neutral"}>
          {row.messageCount > 0 ? "Ready" : "Empty"}
        </Badge>
      </div>
      <p className="text-[12.5px] text-text-muted line-clamp-2">{summary}</p>
      <div className="mt-2 font-mono text-[11px] text-text-faint">
        {row.messageCount} msgs · #{row.sourceChannelId}
      </div>
    </button>
  );
}
